export class ClientesUsuariosModel {
  id_usuario: number;
  id_cliente: number = null;
  id_status: number;
  id_pais: number = null;
  cargo: string;
  master: boolean;
  email: string;
  senha: string;
  senha_conf: string;
  nome: string;
  telefone: string;
  celular: string;
  avatar: string = '/assets/assets/images/faces/face4.png';
  cidade: string;
  estado: string;
  tema: string;
  date_format: string = 'DD/MM/YYYY';
  time_format: string = 'HH:mm';
  timezone: string = 'America/Sao_Paulo';
  idioma: string = 'pt';
  created_at: string;
  updated_at: string;
  deleted_at: string;
  last_login: string;
}



// WEBPACK FOOTER //
// ./src/app/clientes-usuarios/clientes-usuarios.model.ts